module.exports = __webpack_public_path__ + "img/2_1-parco-2-bosco.590f6760.png";